<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
        <el-button-group>
          <el-button type="primary" @click="add" size="small">添加权限</el-button>
        </el-button-group>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="90">
            <template slot-scope="scope">
              <!--禁用-->
              <el-button class="color-danger" type="text" @click="remove(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"></vue-pagination>
    </el-footer>
    <add-permission v-if="addPermission.visible" :dialog-data="addPermission" @table-reload="getTableList"/>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import AddPermission from "./dialog/AddPermission"
  import {getDynamicRoutes} from '@router/permission'
  export default {
    name: "permissionList",
    mixins: [PagingData],
    components: {AddPermission},
    data() {
      return {
        // 统计
        countList: [
          {name: "总记录", count: 0},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "权限名称", property: "name",format: getDynamicRoutes()},
            {label: "描述", property: "describe"},
            {label: "创建时间", property: "create_at"},
            {label: "修改时间", property: "update_at"},
          ]
        },
        addPermission: {
          visible: false,
          title: "",
          row: null,
        }
      }
    },
    methods: {
      add() {
        this.addPermission.title = "添加权限";
        this.addPermission.visible = true;
        this.addPermission.row = null;
      },
      remove(row) {
        this.openConfirm("删除该权限", async ()=> {
          let nv = {};
          nv.optionId = row.id;
          let res = await this.$Http.deletePermission(nv);
          if (res) {
            this.msgSuccess("删除成功");
            this.$refs["paging"].removeFinish(1);
            this.getTableList();
          }
        });
      },
      async getTableList() {
        let params = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        let res = await this.$Http.getPermissionList(params);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      }
    },
    created() {
      this.getTableList();
    }
  }
</script>

<style scoped>

</style>
